module.exports = __webpack_public_path__ + "img/IMG_9483-1200w.92203efd.jpg";